class AddToWishlist extends HTMLElement {
  constructor() {
    super()

    this.productInWishlist = false
    this.wishlistItemId = null

    this.item = {
      productHandle: this.productHandle,
      variantId: this.variantId,
    }

    this.buttonLabels = {
      add: this.dataset.addLabel,
      remove: this.dataset.removeLabel,
    }
  }
  connectedCallback() {
    if (!this.productHandle || !this.variantId) {
      console.warn('WishlistAdd component missing required attributes.')
      return
    }

    this.initWishlist()

    this.addEventListener('click', async (e) => {
      e.preventDefault()
      try {
        if (this.productInWishlist) {
          await this.removeFromWishlist()
        } else {
          await this.addToWishlist()
        }
      } catch (err) {
        console.error('Error handling wishlist toggle', err)
      }
    })
  }

  async initWishlist() {
    if (typeof WishlistKing === 'undefined') {
      return document.addEventListener('wk:app:ready', this.initWishlist, {
        once: true,
      })
    }

    await this.initComponent()
  }

  async initComponent() {
    try {
      await this.fetchWishlistItems()
      await this.checkWishlistProduct()
    } catch (err) {
      console.error('Failed to fetch user wishlist', err)
    }
  }

  async fetchWishlistItems() {
    return new Promise((resolve, reject) => {
      try {
        WishlistKing.state
          .observeWishlist({ wishlistId: 'mine' })
          .subscribe((wishlist) => {
            resolve(wishlist)
          })
      } catch (err) {
        reject(err)
      }
    })
  }

  async checkWishlistProduct() {
    return new Promise((resolve, reject) => {
      try {
        WishlistKing.state
          .observeProductInfo({
            productHandle: this.item.productHandle,
            variantId: this.item.variantId,
          })
          .subscribe((productInfo) => {
            this.productInWishlist = productInfo.inWishlist
            this.wishlistItemId = productInfo.wishlistItemId

            if (productInfo.inWishlist) {
              this.classList.add('quick-buy__wishlist-button--added')
            }

            resolve(productInfo)
          })
      } catch (err) {
        reject(err)
      }
    })
  }

  async addToWishlist() {
    try {
      const result = await WishlistKing.addWishlistItem(this.item)

      this.toggleWishlistState(true)
      return result
    } catch (err) {
      console.error('Wishlist add failed', err)
      throw err
    }
  }

  async removeFromWishlist() {
    try {
      const result = await WishlistKing.removeWishlistItem({
        wishlistItemId: this.wishlistItemId,
      })

      this.toggleWishlistState(false)
      return result
    } catch (err) {
      console.error('Wishlist remove failed', err)
      throw err
    }
  }

  toggleWishlistState(inWishlist) {
    this.classList.toggle('quick-buy__wishlist-button--added', inWishlist)
    this.productInWishlist = inWishlist

    this.setAttribute('aria-pressed', inWishlist)
    this.setAttribute(
      'aria-label',
      inWishlist ? this.buttonLabels.remove : this.buttonLabels.add
    )
  }

  get productHandle() {
    return this.getAttribute('product-handle')
  }

  get variantId() {
    return this.getAttribute('variant-id')
  }
}

if (!customElements.get('wishlist-toggle')) {
  customElements.define('wishlist-toggle', AddToWishlist)
}
